import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import './suggestion-switch.style.scss';

const SuggestionSwitch = ({ entries, currentKey, onChange }) => {
  if (!entries?.length || entries.length < 2) return null;

  return (
    <ToggleButtonGroup
      value={currentKey}
      exclusive
      onChange={(_, value) => value !== null && onChange(value)}
      size="small"
      className="suggestion-switch"
    >
      {entries.map(({ key, label }) => (
        <ToggleButton key={key} value={key}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default SuggestionSwitch;
